/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative}input[_ngcontent-%COMP%]{width:40px;z-index:1}.tool-buttons[_ngcontent-%COMP%]{position:absolute;display:flex;justify-content:space-between;z-index:1;flex-direction:column;height:calc(100% + 46px);top:-23px;right:2px}.second-line.tool-buttons[_ngcontent-%COMP%]{left:2px;right:unset}\n/*# sourceMappingURL=line-with-measure.component.css.map*/"];
export { styles as styles };
